<template>
  <div class="brd-root" :style="themePageStyle">
    <head>
      <meta charset="utf-8" /><title>FLOCKR | Buy Request</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" rel="stylesheet" type="text/css" />
    </head>
    <body :data-sidebar="darkMode ? 'dark' : 'light'">
    <div id="layout-wrapper">
      <nav class="brd-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
            <button class="btn btn-sm btn-link text-muted p-0" @click="$router.push('/marketplace/buy-requests')"><i class="mdi mdi-arrow-left me-1"></i>Buy Requests</button>
          </div>
        </div>
      </nav>

      <div v-if="loading" class="text-center py-5" style="padding-top:100px!important;"><div class="spinner-border text-warning"></div></div>

      <div v-else-if="!request.id" class="text-center py-5" style="padding-top:100px!important;">
        <i class="mdi mdi-file-alert-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
        <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">Buy Request Not Found</h5>
        <button class="btn btn-warning mt-2" @click="$router.push('/marketplace/buy-requests')">Browse Buy Requests</button>
      </div>

      <div v-else class="container brd-container">
        <div class="row">
          <!-- Main Content -->
          <div class="col-lg-8">
            <div class="brd-card mb-3">
              <div class="d-flex align-items-center gap-3 mb-3">
                <div class="brd-avatar">{{ getInitials(request.buyer_name) }}</div>
                <div>
                  <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);">{{ request.buyer_name }}</div>
                  <div v-if="request.buyer_rating" style="color:#f1b44c;font-size:12px;"><i class="mdi mdi-star"></i> {{ Number(request.buyer_rating).toFixed(1) }}</div>
                </div>
                <span class="ms-auto badge bg-success bg-opacity-15 text-success">{{ request.status }}</span>
              </div>

              <h5 class="fw-bold" style="color:var(--fm-h,#F5F0E8);">{{ request.title }}</h5>
              <p v-if="request.description" style="color:var(--fm-m,#A09888);font-size:14px;">{{ request.description }}</p>

              <div class="brd-details">
                <div class="brd-detail"><span class="brd-dl">Species</span><span class="brd-dv">{{ request.species_name }}</span></div>
                <div class="brd-detail" v-if="request.breed_name"><span class="brd-dl">Breed</span><span class="brd-dv">{{ request.breed_name }}</span></div>
                <div class="brd-detail"><span class="brd-dl">Quantity</span><span class="brd-dv">{{ request.quantity_needed }}</span></div>
                <div class="brd-detail" v-if="request.sex_preference && request.sex_preference !== 'any'"><span class="brd-dl">Sex</span><span class="brd-dv">{{ request.sex_preference }}</span></div>
                <div class="brd-detail" v-if="request.min_weight_kg || request.max_weight_kg"><span class="brd-dl">Weight Range</span><span class="brd-dv">{{ request.min_weight_kg || '—' }} – {{ request.max_weight_kg || '—' }} kg</span></div>
                <div class="brd-detail" v-if="request.budget_min || request.budget_max"><span class="brd-dl">Budget</span><span class="brd-dv" style="color:#BFA164;font-weight:700;">KES {{ formatPrice(request.budget_min) }} – {{ formatPrice(request.budget_max) }} ({{ request.price_type }})</span></div>
                <div class="brd-detail" v-if="request.delivery_location"><span class="brd-dl">Delivery</span><span class="brd-dv">{{ request.delivery_location }}</span></div>
                <div class="brd-detail" v-if="request.needed_by"><span class="brd-dl">Needed By</span><span class="brd-dv" style="color:#f1b44c;">{{ formatDate(request.needed_by) }}</span></div>
                <div class="brd-detail"><span class="brd-dl">Posted</span><span class="brd-dv">{{ formatDate(request.created_at) }}</span></div>
              </div>
            </div>

            <!-- Responses -->
            <div class="brd-card">
              <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-comment-multiple-outline me-2"></i>Responses ({{ responses.length }})</h6>
              <div v-if="loadingResponses" class="text-center py-3"><div class="spinner-border spinner-border-sm text-warning"></div></div>
              <div v-else-if="responses.length === 0" class="text-center py-3"><p style="color:var(--fm-s,#6B6356);font-size:13px;">No responses yet. Be the first to respond!</p></div>
              <div v-else>
                <div v-for="(resp,ri) in responses" :key="'r-'+ri" class="brd-resp">
                  <div class="d-flex align-items-center gap-3">
                    <div class="brd-avatar-sm">{{ getInitials(resp.seller_name) }}</div>
                    <div class="flex-fill">
                      <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ resp.seller_name }} <span v-if="resp.seller_rating" style="color:#f1b44c;font-size:11px;"><i class="mdi mdi-star"></i>{{ Number(resp.seller_rating).toFixed(1) }}</span></div>
                      <div style="color:#BFA164;font-weight:700;">KES {{ formatPrice(resp.offered_price) }} <span style="color:var(--fm-s,#6B6356);font-weight:400;font-size:11px;">({{ resp.price_type }}) × {{ resp.offered_quantity }}</span></div>
                      <div class="d-flex align-items-center gap-2 mt-1">
                        <span style="color:#50C878;font-weight:700;font-size:13px;">Total: KES {{ formatPrice(respTotal(resp)) }}</span>
                      </div>
                      <div v-if="resp.avg_weight_kg" style="color:var(--fm-m,#A09888);font-size:11px;">Avg weight: {{ resp.avg_weight_kg }}kg</div>
                      <div v-if="resp.message" class="mt-1" style="color:var(--fm-m,#A09888);font-size:12px;background:var(--fm-bg2,#0F0F0F);padding:8px 10px;border-radius:6px;border-left:2px solid #2A2520;">{{ resp.message }}</div>
                    </div>
                    <span class="badge" :class="resp.status==='pending'?'bg-warning bg-opacity-15 text-warning':resp.status==='accepted'?'bg-success bg-opacity-15 text-success':resp.status==='rejected'?'bg-danger bg-opacity-15 text-danger':'bg-secondary bg-opacity-15 text-muted'" style="font-size:10px;">{{ resp.status }}</span>
                  </div>

                  <!-- BUYER ACTIONS (only for request owner) -->
                  <div v-if="isOwner && resp.status==='pending'" class="brd-resp-actions">
                    <button class="btn btn-sm brd-btn-accept" @click="acceptResponse(resp)" :disabled="processing">
                      <i class="mdi mdi-check-circle me-1"></i>Accept & Order
                    </button>
                    <button class="btn btn-sm brd-btn-msg" @click="messageResponse(resp)">
                      <i class="mdi mdi-message-text me-1"></i>Message
                    </button>
                    <button class="btn btn-sm brd-btn-reject" @click="rejectResponse(resp)" :disabled="processing">
                      <i class="mdi mdi-close-circle me-1"></i>Decline
                    </button>
                  </div>

                  <!-- ACCEPTED: show checkout button -->
                  <div v-if="isOwner && resp.status==='accepted'" class="brd-resp-actions">
                    <button class="btn btn-sm btn-warning fw-bold" @click="goToCheckout(resp)">
                      <i class="mdi mdi-cart-arrow-right me-1"></i>Proceed to Checkout
                    </button>
                    <button class="btn btn-sm brd-btn-msg" @click="messageResponse(resp)">
                      <i class="mdi mdi-message-text me-1"></i>Message Seller
                    </button>
                  </div>

                  <!-- Seller: view their response status -->
                  <div v-if="!isOwner && resp.seller_id===myUserId && resp.status==='accepted'" class="brd-resp-accepted-note">
                    <i class="mdi mdi-check-decagram me-1" style="color:#50C878;"></i>Your response was accepted! The buyer will proceed to checkout.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sidebar: Respond Form -->
          <div class="col-lg-4 mt-3 mt-lg-0">
            <div class="brd-card" v-if="!isOwner">
              <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-reply me-2"></i>Respond to Request</h6>
              <div class="mb-2">
                <label class="brd-label">Offered Price (KES) <span class="text-danger">*</span></label>
                <input v-model="respForm.offeredPrice" type="number" class="form-control brd-input" placeholder="0.00" />
              </div>
              <div class="mb-2">
                <label class="brd-label">Quantity Available <span class="text-danger">*</span></label>
                <input v-model="respForm.offeredQuantity" type="number" class="form-control brd-input" min="1" placeholder="e.g. 50" />
              </div>
              <div class="mb-2">
                <label class="brd-label">Avg Weight (kg)</label>
                <input v-model="respForm.avgWeightKg" type="number" step="0.1" class="form-control brd-input" placeholder="Optional" />
              </div>
              <div class="mb-2">
                <label class="brd-label">Price Type</label>
                <select v-model="respForm.priceType" class="form-select brd-input">
                  <option value="per_unit">Per Unit</option>
                  <option value="per_kg">Per Kg</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="brd-label">Message</label>
                <textarea v-model="respForm.message" class="form-control brd-input" rows="3" placeholder="Describe your stock..."></textarea>
              </div>
              <div v-if="respError" class="mb-2" style="color:#FF6B6B;font-size:12px;">{{ respError }}</div>
              <button class="btn btn-warning w-100" @click="submitResponse" :disabled="!respForm.offeredPrice || !respForm.offeredQuantity || respSubmitting">
                <span v-if="respSubmitting"><span class="spinner-border spinner-border-sm me-1"></span></span>
                <span v-else><i class="mdi mdi-send me-1"></i> Submit Response</span>
              </button>
            </div>

            <div class="brd-card" v-if="isOwner">
              <h6 class="fw-bold mb-2" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-clipboard-text me-2" style="color:#BFA164;"></i>Your Buy Request</h6>
              <div class="brd-owner-stats">
                <div class="brd-owner-stat"><span>Responses</span><strong style="color:#BFA164;">{{ responses.length }}</strong></div>
                <div class="brd-owner-stat"><span>Accepted</span><strong style="color:#50C878;">{{ responses.filter(function(r){return r.status==='accepted'}).length }}</strong></div>
                <div class="brd-owner-stat"><span>Best Price</span><strong style="color:#50C878;">{{ responses.length ? 'KES '+formatPrice(Math.min.apply(null,responses.map(function(r){return Number(r.offered_price)}))) : '—' }}</strong></div>
              </div>
              <p style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:12px;">Click <strong style="color:#50C878;">Accept & Order</strong> on a response to start the purchase, or <strong style="color:#BFA164;">Message</strong> to negotiate.</p>
              <div class="d-flex flex-column gap-2 mt-3">
                <button class="btn btn-sm btn-outline-warning w-100" @click="$router.push('/marketplace/buy-requests/create')"><i class="mdi mdi-plus me-1"></i>New Buy Request</button>
                <button v-if="request.status==='active'" class="btn btn-sm btn-outline-danger w-100" @click="closeRequest" :disabled="processing"><i class="mdi mdi-close-circle me-1"></i>Close Request</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </body>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>

<style>
:root{
  --fm-h:#F5F0E8;
  --fm-s:#6B6356;
  --fm-m:#A09888;
  --fm-bg1:#141414;
  --fm-bg2:#0F0F0F;
  --fm-bg3:#1E1E1E;
  --fm-br:#1E1E1E;
  --fm-page:#0A0A0A;
}
html[data-theme="light"]{
  --fm-h:#1A1A1A;
  --fm-s:#777777;
  --fm-m:#555555;
  --fm-bg1:#FFFFFF;
  --fm-bg2:#F7F5F2;
  --fm-bg3:#F0EBE4;
  --fm-br:#E8E2DA;
  --fm-page:#F7F5F2;
}
html[data-theme="light"] body,
html[data-theme="light"] #layout-wrapper,
html[data-theme="light"] .brd-root,
html[data-theme="light"] .brd-container{background:var(--fm-page)!important;color:var(--fm-h)!important;}
html[data-theme="dark"] body,
html[data-theme="dark"] #layout-wrapper,
html[data-theme="dark"] .brd-root,
html[data-theme="dark"] .brd-container{background:var(--fm-page)!important;color:var(--fm-h)!important;}
html[data-theme="light"] .brd-topbar{background:#FFFFFF!important;border-bottom-color:#E8E2DA!important;}
html[data-theme="dark"] .brd-topbar{background:var(--fm-bg1,#141414)!important;}
html[data-theme="light"] .brd-card,
html[data-theme="light"] .brd-sidebar-card,
html[data-theme="light"] .brd-response-card{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important;}
html[data-theme="light"] .brd-title,
html[data-theme="light"] .brd-section-title,
html[data-theme="light"] .brd-price,
html[data-theme="light"] .brd-budget,
html[data-theme="light"] .brd-dv{color:#1A1A1A!important;}
html[data-theme="light"] .brd-meta,
html[data-theme="light"] .brd-label,
html[data-theme="light"] .brd-dl,
html[data-theme="light"] .brd-empty{color:#555!important;}
html[data-theme="light"] .brd-input,
html[data-theme="light"] textarea,
html[data-theme="light"] input,
html[data-theme="light"] select{background:#FFFFFF!important;color:#1A1A1A!important;border-color:#E0D8D0!important;}
html[data-theme="light"] .brd-input::placeholder,
html[data-theme="light"] textarea::placeholder,
html[data-theme="light"] input::placeholder{color:#777!important;}
</style>

<style scoped>
.brd-root{background:var(--fm-page,#0A0A0A)!important;min-height:100vh;color:var(--fm-h,#F5F0E8)!important}
.brd-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.brd-container{padding-top:80px;padding-bottom:60px;max-width:1000px}
.brd-card,.brd-sidebar-card,.brd-response-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:20px}
.brd-avatar{width:44px;height:44px;border-radius:50%;background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#BFA164;flex-shrink:0}
.brd-avatar-sm{width:34px;height:34px;border-radius:50%;background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:#BFA164;flex-shrink:0}
.brd-details{margin-top:16px}
.brd-detail{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--fm-br,#1A1A1A);font-size:13px}
.brd-detail:last-child{border-bottom:none}
.brd-dl{color:var(--fm-s,#6B6356)}
.brd-dv{color:#D4C9B8}
.brd-resp{padding:14px 0;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.brd-resp:last-child{border-bottom:none}
.brd-label{font-size:12px;font-weight:600;color:#D4C9B8;margin-bottom:4px;display:block}
.brd-input{background:var(--fm-bg2,#0F0F0F)!important;border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);border-radius:8px;font-size:13px}
.brd-input:focus{border-color:#BFA164;box-shadow:0 0 0 2px rgba(191,161,100,.15);background:var(--fm-bg2,#0F0F0F);color:var(--fm-h,#F5F0E8)}
.brd-input option{background:var(--fm-bg1,#141414)!important;color:var(--fm-h,#F5F0E8)}
.brd-resp-actions{display:flex;gap:8px;margin-top:10px;padding-top:10px;border-top:1px solid var(--fm-br,#1A1A1A)}
.brd-btn-accept{background:rgba(80,200,120,0.12);border:1px solid rgba(80,200,120,0.25);color:#50C878;font-size:12px;font-weight:600;border-radius:8px}
.brd-btn-accept:hover{background:rgba(80,200,120,0.2);color:#50C878}
.brd-btn-reject{background:rgba(255,107,107,0.08);border:1px solid rgba(255,107,107,0.2);color:#FF6B6B;font-size:12px;font-weight:600;border-radius:8px}
.brd-btn-reject:hover{background:rgba(255,107,107,0.15);color:#FF6B6B}
.brd-btn-msg{background:rgba(191,161,100,0.1);border:1px solid rgba(191,161,100,0.2);color:#BFA164;font-size:12px;font-weight:600;border-radius:8px}
.brd-btn-msg:hover{background:rgba(191,161,100,0.2);color:#BFA164}
.brd-resp-accepted-note{margin-top:8px;padding:8px 12px;background:rgba(80,200,120,0.06);border:1px solid rgba(80,200,120,0.15);border-radius:8px;font-size:12px;color:#50C878}
.brd-owner-stats{display:flex;gap:12px;margin-top:12px}
.brd-owner-stat{flex:1;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:10px;text-align:center}
.brd-owner-stat span{display:block;font-size:10px;color:var(--fm-s,#6B6356);text-transform:uppercase}
.brd-owner-stat strong{display:block;font-size:16px;margin-top:2px}
</style>
<script>
/* eslint-disable */
import {  executeJson, flocker  } from "@/api";

function applyBuyReqTheme(vm) {
  const t = document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || (vm && vm.darkMode ? 'dark' : 'light');
  const isDark = t !== 'light';
  if (vm) vm.darkMode = isDark;
  window.__flockrSetTheme(isDark ? 'dark' : 'light');

  if (document.body) {
    document.body.setAttribute('data-sidebar', isDark ? 'dark' : 'light');
    document.body.style.background = isDark ? '#0A0A0A' : '#F7F5F2';
    document.body.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }

  const wrapper = document.getElementById('layout-wrapper');
  if (wrapper) {
    wrapper.style.background = isDark ? '#0A0A0A' : '#F7F5F2';
    wrapper.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }
}

export default {
  name: "BuyRequestDetail",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    loading:true,loadingResponses:true,respSubmitting:false,respError:'',processing:false,request:{},responses:[],respForm:{offeredPrice:'',offeredQuantity:'',avgWeightKg:'',priceType:'per_unit',message:''}}},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    isOwner(){return this.request.buyer_id===sessionStorage.getItem('userId')},
    myUserId(){return sessionStorage.getItem('userId')||''}
  },
  mounted(){
    applyBuyReqTheme(this);
    this.themeObserver = new MutationObserver(() => applyBuyReqTheme(this));
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });
    var id=this.$route.params.id;if(id)this.load(id)},
  beforeUnmount(){
    if(this.themeObserver)this.themeObserver.disconnect()
  },
  methods:{
    async load(id){
      this.loading=true;
      try{var r=await executeJson({function:"getBuyRequests",keyword:''},flocker);if(r.data.success){var found=(r.data.data.buyRequests||[]).find(function(b){return b.id===id});if(found)this.request=found}}catch(e){console.error(e)}
      this.loading=false;this.fetchResponses(id)
    },
    async fetchResponses(id){
      this.loadingResponses=true;
      try{var r=await executeJson({function:"getBuyRequestResponses",buyRequestId:id},flocker);if(r.data.success)this.responses=r.data.data.responses||[]}catch(e){console.error(e)}
      this.loadingResponses=false
    },
    async submitResponse(){
      this.respSubmitting=true;this.respError='';
      try{
        var p={function:"respondToBuyRequest",buyRequestId:this.request.id,sellerId:sessionStorage.getItem('userId'),offeredQuantity:this.respForm.offeredQuantity,offeredPrice:this.respForm.offeredPrice,priceType:this.respForm.priceType,message:this.respForm.message};
        if(this.respForm.avgWeightKg)p.avgWeightKg=this.respForm.avgWeightKg;
        var r=await executeJson(p,flocker);
        if(r.data.success){this.respForm={offeredPrice:'',offeredQuantity:'',avgWeightKg:'',priceType:'per_unit',message:''};this.fetchResponses(this.request.id)}
        else{this.respError=r.data.message||'Failed to submit.'}
      }catch(e){this.respError='Something went wrong.'}
      this.respSubmitting=false
    },
    respTotal(resp) {
      var price = Number(resp.offered_price) || 0;
      var qty = Number(resp.offered_quantity) || 1;
      return price * qty;
    },
    async acceptResponse(resp) {
      if (!confirm('Accept this offer from ' + resp.seller_name + ' for KES ' + this.formatPrice(this.respTotal(resp)) + '?\n\nYou can then proceed to checkout.')) return;
      this.processing = true;
      try {
        var r = await executeJson({ function:'manageBuyRequestResponse', responseId: resp.id, action:'accept', buyRequestId: this.request.id }, flocker);
        if (r.data.success) { this.fetchResponses(this.request.id); }
        else { alert(r.data.message || 'Failed'); }
      } catch(e) { alert('Network error'); }
      this.processing = false;
    },
    async rejectResponse(resp) {
      if (!confirm('Decline response from ' + resp.seller_name + '?')) return;
      this.processing = true;
      try {
        var r = await executeJson({ function:'manageBuyRequestResponse', responseId: resp.id, action:'reject', buyRequestId: this.request.id }, flocker);
        if (r.data.success) { this.fetchResponses(this.request.id); }
        else { alert(r.data.message || 'Failed'); }
      } catch(e) { alert('Network error'); }
      this.processing = false;
    },
    messageResponse(resp) {
      // Navigate to chat with seller
      this.$router.push({ path: '/messages/' + resp.seller_id, query: { name: resp.seller_name, ref: 'buyrequest', refId: this.request.id } });
    },
    goToCheckout(resp) {
      // Navigate to checkout with buy request response context
      this.$router.push({ path: '/checkout/' + resp.id, query: { type: 'buy_request', buyRequestId: this.request.id, sellerId: resp.seller_id, sellerName: resp.seller_name, price: resp.offered_price, quantity: resp.offered_quantity, priceType: resp.price_type, species: this.request.species_name, title: this.request.title } });
    },
    async closeRequest() {
      if (!confirm('Close this buy request? It will no longer accept responses.')) return;
      this.processing = true;
      try {
        var r = await executeJson({ function:'updateBuyRequestStatus', requestId: this.request.id, status:'cancelled' }, flocker);
        if (r.data.success) { this.request.status = 'cancelled'; }
        else { alert(r.data.message || 'Failed'); }
      } catch(e) { alert('Network error'); }
      this.processing = false;
    },
    formatPrice(a){return a?Number(a).toLocaleString('en-KE'):'0'},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})},
    getInitials(n){if(!n)return'?';return n.split(' ').map(function(w){return w[0]}).join('').substring(0,2).toUpperCase()}
  }
};
</script>
